import ObjectCard from './component'

export default ObjectCard